import { useState } from "react";
import axios from "axios";

let cachedToken = null;
let tokenExpiry = null;
let pendingPromise = null;

const TOKEN_TTL = 25 * 60 * 1000; 

export default function useCGFAI() {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [token, setToken] = useState(null);

  const fetchToken = async () => {
    const now = Date.now();

    if (cachedToken && tokenExpiry && now < tokenExpiry) {
      return cachedToken;
    }

    if (pendingPromise) {
      return pendingPromise;
    }

    pendingPromise = (async () => {
      const authToken = localStorage.getItem("authToken");

      const response = await axios.get(
        `${process.env.REACT_APP_ORIGIN}/api/v1/auth/cgf-login`,
        {
          headers: { token: authToken },
        }
      );

      const accessToken = response.data.accessToken;

      if (!accessToken) {
        throw new Error("No token received");
      }

      cachedToken = accessToken;
      tokenExpiry = Date.now() + TOKEN_TTL;

      return accessToken;
    })();

    try {
      const token = await pendingPromise;
      return token;
    } finally {
      pendingPromise = null;
    }
  };

  const handleOpen = async () => {
    setIsOpen(true);
    setLoading(true);
    setError(false);

    try {
      const accessToken = await fetchToken();
      setToken(accessToken);
    } catch (err) {
      cachedToken = null;
      tokenExpiry = null;
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleRetry = () => handleOpen();

  const handleClose = () => {
    setIsOpen(false);
    setToken(null);
    setError(false);
  };

  return {
    handleOpen,
    handleRetry,
    handleClose,
    error,
    token,
    loading,
    isOpen,
  };
}
